export default __webpack_public_path__ + "static/media/upload_cloud.9159cff1.svg";